$(function () {

    /*
     Custom Select add down arrow
     */
    //$('form select').customSelect();
    //$('.customSelect').append('<span class="arrow"><i class="font-down-arrow"></i></span>');


    // Fill me in!

    var  $body = $('body');


    $body
        .on('click', '.accordion .accordion__handle', function AccordionToggle() {
            var $container = $(this).closest('.accordion-container');

            var $accordion = $(this).closest('.accordion');

            var $trigger = $('.accordion__handle', $accordion);

            var $content =  $('.accordion__panel', $accordion);

            var $allContent = $('.accordion__panel', $container);

            var $allTriggers = $('.accordion__handle', $container);

            if ($trigger.hasClass('active')) {
                $allContent.slideUp();
                $allContent.removeClass('active');
                $trigger.removeClass('active');
                $content.removeClass('active');
            } else {
                $allContent.slideUp();
                $allContent.removeClass('active');
                $allTriggers.removeClass('active');
                $trigger.addClass('active');
                $content.addClass('active');
                $content.slideDown();
            }
        })
        .on('click', 'header .nav-toggle-menu', function toggleMenu(){
            var $header = $('header');
            if($header.hasClass('show')){
                $('.nav-toggle-menu i', $header).removeClass('icon-cancel');
                $('.nav-toggle-menu i', $header).addClass('icon-menu')

            }else{
                $('.nav-toggle-menu i', $header).addClass('icon-cancel');
                $('.nav-toggle-menu i', $header).removeClass('icon-menu');
            }
            $header.toggleClass('show');
        })
        .on('click', 'header .menu__item--toggle', function toggleSubmenu(e){
            e.preventDefault();
            var $container = $(this).closest('.menu__item')
            if($('.menu__item--submenu', $container).hasClass('show')){
                if(e.target.href.substr(e.target.href.length - 1) !== '#'){
                    window.location = e.target.href;
                }
                $('i', this).removeClass('icon-right-open');
                $('i', this).addClass('icon-down-open');
            }else{
                $('i', this).removeClass('icon-down-open');
                $('i', this).addClass('icon-right-open');
            }
            $('.menu__item--submenu', $container).toggleClass('show');
        })
        .on('change','.js-select-jumpto',function(e){
            window.location.href = $(this).val();
        })
        .on('click', '.js-share-reveal', function(e){
            e.preventDefault();
            var $parent = $(this).closest('.share-container');
            $('.button', $parent).addClass('hide');
            $('.share-icons', $parent).addClass('show');

        })
        .on( 'click', '.slider-container .slider-controls .left, .slider-container .slider-controls .right', function () {
            if ( $( this ).hasClass( 'disabled' ) ) {
                return false;
            }

            const $sliderContainer = $( this ).closest( '.slider-container' );
            const $slider = $( '.slider', $sliderContainer );

            if ( $( this ).hasClass( 'left' ) ) {
                $slider.slick( 'slickPrev' );
            } else {
                $slider.slick( 'slickNext' );
            }
        } )
    ;

    function lerp(start, end, multiplier) {
        return start * (1 - multiplier) + end * multiplier
    }

    var $spark_container = $('#spark-container');
    var $sparks_svgs = $('svg, div', $spark_container);
    var $sparks_array = [];
    var $data_sparks = $('.js-sparks');

    function Spark(element, bounds){
        this.element = element;
        this.currentBounds = bounds;
        this.prevx = randomNumberFromRange(bounds.x, bounds.x + bounds.width);
        this.prevy = randomNumberFromRange(bounds.y, bounds.y + bounds.height);
        this.currentx =  randomNumberFromRange(bounds.x, bounds.x + bounds.width);
        this.currenty = randomNumberFromRange(bounds.x, bounds.x + bounds.width);
        this.finalx = randomNumberFromRange(bounds.x, bounds.x + bounds.width);
        this.finaly = randomNumberFromRange(bounds.y, bounds.y + bounds.height);

        $(this.element).css('transform', 'translate(' + this.prevx + 'px, '+ this.prevy  + 'px)');

        this.loop();
    };

    Spark.prototype = {
        update: function(top, left, width, height){
            this.prevx = this.currentx;
            this.prevy = this.currenty;
            this.finalx = randomNumberFromRange(left, left + width);
            this.finaly = randomNumberFromRange(top, top + height);
        },
        loop: function() {
            this.currentx = lerp(this.currentx, this.finalx, 0.05);
            this.currenty = lerp(this.currenty, this.finaly, 0.05);
            $(this.element).css('transform', 'translate(' + this.currentx + 'px, ' + this.currenty + 'px)');


            requestAnimationFrame(this.loop.bind(this));
        }
    };

    if($data_sparks.length > 0){
        for(var i = 0; i < $sparks_svgs.length; i++){
            var spark = new Spark($sparks_svgs[i], $data_sparks[0].getBoundingClientRect());
            $sparks_array.push(spark);
        }
    }

    var bodyheight = document.body.getBoundingClientRect().height;

    // $spark_container.height(bodyheight);

    function randomNumberFromRange(min,max) {
        return  Math.floor(Math.abs(Math.random()*(max-min+1)+min));
    };

    function sparks_callback(entry, observer){
        for(var i = 0; i < entry.length; i++){
            if(entry[i].isIntersecting) {
                for(var j = 0; j < $sparks_array.length; j++) {
                    $sparks_array[j].update($(entry[i].target).offset().top, $(entry[i].target).offset().left, $(entry[i].target).width(), $(entry[i].target).height())
                }
            }
        }
    };

    window.addEventListener('resize', function(e){
        var bounds = document.body.getBoundingClientRect();
        for(var i = 0; i < $sparks_array.length; i++){
            if($sparks_array[i].currentx > (bounds.width - 40)){
                $sparks_array[i].currentx = $sparks_array[i].currentx / 2;
                $sparks_array[i].finalx = $sparks_array[i].finalx / 2;
            }
        }
    })

    var observer = new IntersectionObserver(sparks_callback, {
        root: document.querySelector('#scrollArea'),
        rootMargin: '0px',
        threshold: 1.0
    });

    if($spark_container) {
        $('.js-sparks').each(function () {
            observer.observe(this);
            // console.log('observed');
        });

        var spark_1 = {
            container: document.getElementById('spark-1'), // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '' + distsrc + '/images/blue-burst.json' // the path to the animation json
        };

        var spark_2 = {
            container: document.getElementById('spark-1'), // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '' + distsrc + '/images/green-cross.json' // the path to the animation json
        };

        var spark_3 = {
            container: document.getElementById('spark-3'), // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '' + distsrc + '/images/pink-circle.json' // the path to the animation json
        };

        var spark_4 = {
            container: document.getElementById('spark-4'), // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '' + distsrc + '/images/yellow-star.json' // the path to the animation json
        };

        var spark_5 = {
            container: document.getElementById('spark-5'), // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '' + distsrc + '/images/blue-burst.json' // the path to the animation json
        };

        var spark_6 = {
            container: document.getElementById('spark-6'), // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '' + distsrc + '/images/green-cross.json' // the path to the animation json
        };

        var spark_7 = {
            container: document.getElementById('spark-7'), // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '' + distsrc + '/images/pink-circle.json' // the path to the animation json
        };

        var spark_8 = {
            container: document.getElementById('spark-8'), // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '' + distsrc + '/images/yellow-star.json' // the path to the animation json
        };

        var spark_9 = {
            container: document.getElementById('spark-9'), // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '' + distsrc + '/images/blue-burst.json' // the path to the animation json
        };

        var spark_10 = {
            container: document.getElementById('spark-10'), // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '' + distsrc + '/images/green-cross.json' // the path to the animation json
        };

        lottie.loadAnimation(spark_1);
        lottie.loadAnimation(spark_2);
        lottie.loadAnimation(spark_3);
        lottie.loadAnimation(spark_4);
        lottie.loadAnimation(spark_5);
        lottie.loadAnimation(spark_6);
        lottie.loadAnimation(spark_7);
        lottie.loadAnimation(spark_8);
        lottie.loadAnimation(spark_9);
        lottie.loadAnimation(spark_10);
    }

    const testimonialSettings = {
        type: 'slider',
        autoplay: 5000,
        perView: 1,
        keyboard: false,
        swipeThreshold: false,
        dragThreshold: false,
    }

    if ($('.glide').length>0) {
        new Glide('.glide', testimonialSettings).mount()
    }


    // Public stats
    if ($('.public-stats').length) {
        let statInit = setInterval(function () {
            if (typeof countUp !== 'undefined') {
                clearInterval(statInit);
                doStats();
            }
        }, 100);

        function doStats() {
            $('.public-stats').find('.stat-stat').each(function (i, e) {
                let counter = new countUp.CountUp($(e)[0], $(e).data('number'), {
                    duration: 3,
                    enableScrollSpy: true
                });

                if (!counter.error) {
                    counter.start();
                }
            });
        }
    }
});

function expandFunction() {
    var sampleElem = document.getElementById("helpline-button");
    var element = document.getElementById("button-helpline-expand");
    if (sampleElem.className === "button-helpline") {
        sampleElem.className = "hide-helpline-button";
        element.className = "hide-helpline";
    } else {
        sampleElem.className = "button-helpline";
        element.className = "hide-helpline-button";
    }
}

